export default __webpack_public_path__ + "static/media/trustwallet.4ea74a77.svg";